var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3688_151977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.27846 11.1152C9.41702 11.1789 9.57312 11.1934 9.72104 11.1564C9.86896 11.1195 9.99989 11.0333 10.0922 10.9119L10.3304 10.6C10.4554 10.4333 10.6175 10.2981 10.8038 10.2049C10.9901 10.1118 11.1955 10.0633 11.4038 10.0633H13.4165C13.7723 10.0633 14.1136 10.2046 14.3652 10.4563C14.6169 10.7079 14.7582 11.0492 14.7582 11.405V13.4177C14.7582 13.7735 14.6169 14.1148 14.3652 14.3665C14.1136 14.6181 13.7723 14.7595 13.4165 14.7595C10.2137 14.7595 7.14219 13.4872 4.87752 11.2225C2.61285 8.95784 1.34058 5.88629 1.34058 2.68356C1.34058 2.3277 1.48194 1.98642 1.73357 1.73479C1.9852 1.48316 2.32648 1.3418 2.68234 1.3418H4.69499C5.05085 1.3418 5.39213 1.48316 5.64376 1.73479C5.89539 1.98642 6.03676 2.3277 6.03676 2.68356V4.69621C6.03676 4.90451 5.98826 5.10996 5.8951 5.29627C5.80195 5.48258 5.66669 5.64464 5.50005 5.76962L5.18608 6.0051C5.06291 6.09915 4.9761 6.23293 4.94039 6.38372C4.90468 6.53451 4.92227 6.69301 4.99018 6.8323C5.90706 8.69458 7.41503 10.2007 9.27846 11.1152Z",
    stroke: "#99A1AF",
    strokeWidth: 1.34177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3688_151977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.1012,
    height: 16.1012,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.dbd6e8bccae5f2cdb4379065e13261d3.svg";
export { ForwardRef as ReactComponent };